import type { CensusField } from '@/job-architecture-builder/types';

export const JOB_ARCHITECTURE_BUILDER_FLAG = 'job_architecture_builder';

export const CENSUS_FIELDS: CensusField[] = [
  'employee_id',
  'job_title',
  'manager_employee_id',
  'level',
  'name',
  'department',
  'location',
  'salary',
  'currency',
];
export const REQUIRED_CENSUS_FIELDS: CensusField[] = ['employee_id', 'job_title'];
export const LEVEL_SOURCE_FIELDS: CensusField[] = ['manager_employee_id', 'level'];

export const SAMPLE_ROWS = 5;
export const PROGRESS_POLL_INTERVAL_MS = 1500;
export const COMPA_RATIO_LOW = 0.8;
export const COMPA_RATIO_HIGH = 1.2;
export const SURVEY_CURRENCY = 'USD';
// Shown in empty table cells: a blank cell reads as something broken.
export const EMPTY_CELL = '–';
export const MIN_PEERS = 2;
// Pay further than this from the peer median makes an employee an outlier among peers.
export const PEER_OUTLIER = 0.1;
export const PAY_ELEMENTS = ['base', 'equity'] as const;
export const PROGRESSION_KEYS = ['start', 'deduction', 'minimum', 'maximum'] as const;
// Mirror of the defaults in apps/job_architecture_builder/services/build_ranges.py and range_math.py.
export const DEFAULT_SPREADS = { base: 0.2, equity: 0.3 };
export const DEFAULT_VESTING_YEARS = 4;
export const DEFAULT_BASE_ROUNDING = 500;
export const DEFAULT_PROGRESSIONS = {
  base: { start: 0.3, deduction: 0.02, minimum: 0.1, maximum: 0.3 },
  equity: { start: 0.6, deduction: 0.02, minimum: 0.1, maximum: 0.7 },
};
// Mirror of the Survey levels (load_survey_levels in load_reference_data.py), lowest first per track.
export const SURVEY_LEVELS = [
  ...['S1', 'S2', 'S3', 'S4'],
  ...['P1', 'P2', 'P3', 'P4', 'P5', 'P6'],
  ...['M1', 'M2', 'M3', 'M4', 'M5', 'M6'],
  ...['E1', 'E2', 'E3'],
];
// Squirrel p-red-40, p-green-40, p-blue-40, p-gray-40.
export const COMPA_COLORS = { below: '#f45148', within: '#27b478', above: '#6666ae', none: '#918da1' } as const;
